import * as React from "react";
import { BaseComponent } from "../../BaseComponent";
import * as Data from "../../../Data";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../Trad";
import { CampoData } from "../../CampoData";
import { Tipo } from "../../Tipi";
import { DateRangeData, DateRanges, DateRangeType, GetDateRange } from "../../../helpers/DateHelper";

const DataRange: DateRangeType = {
    [DateRanges.CurrentMonth]: GetDateRange(DateRanges.CurrentMonth),
    [DateRanges.LastMonth]: GetDateRange(DateRanges.LastMonth),
    [DateRanges.CurrentWeek]: GetDateRange(DateRanges.CurrentWeek),
    [DateRanges.LastWeek]: GetDateRange(DateRanges.LastWeek),
    [DateRanges.LastQuarter]: GetDateRange(DateRanges.LastQuarter)
};

interface IDateRangeProps {
    OnChange: (e: React.FormEvent<any> | string, value: any) => void;
    OnRangeChange: (value: DateRangeData) => void;
    DateFrom: Date | string;
    DateTo: Date | string;
}

interface IDateRangeState {
    RangeValue: string;
}

export class DateRange extends BaseComponent<IDateRangeProps, IDateRangeState> {
    private _RangeOptions: Dati.TDictTipo = {};

    constructor(props: IDateRangeProps) {
        super(props);
        this.state = { RangeValue: DateRanges.CurrentMonth };

        this.SelectRange = this.SelectRange.bind(this);
        this.OnChange = this.OnChange.bind(this);

        Object.keys(DateRanges).forEach(range => {
            this._RangeOptions[range] = new Dati.CTipo(range, DateRanges[range]);
        });
    }

    SelectRange(e: string, value: any) {
        this.props.OnRangeChange(DataRange[value]);
        this.setState({ RangeValue: value });
    }

    OnChange(e: React.FormEvent<any> | string, value: any) {
        let DataValore: Data.CData = new Data.CData(value, true);
        this.setState({ RangeValue: "" });
        this.props.OnChange(e, DataValore);
    }

    render() {
        return (
            <div className="row kt-padding-b-15">
                <div className={Glob.DimensioneCSS(6)}>
                    <label>{Trad.Trad("Range")}</label>
                    <Tipo Dati={this._RangeOptions} ID_ChiaveString={this.state.RangeValue} OnAggiorna={this.SelectRange} TradValori />
                </div>
                <div className="col">
                    <div className="row">
                        <div className={Glob.DimensioneCSS(6)}>
                            <label className="">{Trad.Trad("Inizio")}</label>
                            <div className="form-control">
                                <CampoData ValoreInArrivo Name="DateFrom" Id="DateFrom" Valore={this.props.DateFrom} OnChange={this.OnChange} />
                            </div>
                        </div>

                        <div className={Glob.DimensioneCSS(6)}>
                            <label className="">{Trad.Trad("Fine")}</label>
                            <div className="form-control">
                                <CampoData ValoreInArrivo Name="DateTo" Id="DateTo" Valore={this.props.DateTo} OnChange={this.OnChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/custom/DateRange/DateRange.tsx